module.exports = __webpack_public_path__ + "static/media/bytt-nn-2.acee54ff.mp3";